export const ORDER_TYPE_OPTIONS = [
  {
    id: 1,
    label: "Customer",
    isMold: false,
    requireShipment: false,
    allowEdit: true,
    referenceWorkOrder: false,
    isOutbound: false,
    isService: false,
  },
  {
    id: 2,
    label: "Mold",
    isMold: true,
    requireShipment: false,
    allowEdit: true,
    referenceWorkOrder: false,
    isOutbound: true,
    isService: false,
  },
  {
    id: 3,
    label: "Raw Materials",
    isMold: false,
    requireShipment: false,
    allowEdit: true,
    referenceWorkOrder: false,
    isOutbound: true,
    isService: false,
  },
  {
    id: 4,
    label: "Vendor Processing",
    isMold: false,
    requireShipment: true,
    allowEdit: false,
    referenceWorkOrder: true,
    isOutbound: true,
    isService: true,
  },
  {
    id: 5,
    label: "Vendor Testing",
    isMold: false,
    requireShipment: false,
    allowEdit: false,
    referenceWorkOrder: true,
    isOutbound: true,
    isService: true,
  },
  // {
  //   id: 6,
  //   label: "Vendor Manufacturing",
  //   isMold: false,
  //   requireShipment: false,
  //   allowEdit: true,
  //   referenceWorkOrder: true,
  //   isOutbound: true,
  //   isService: false,
  // },
  // {
  //   id: 7,
  //   label: "Vendor Shipment",
  //   isMold: false,
  //   requireShipment: true,
  //   allowEdit: false,
  //   referenceWorkOrder: true,
  //   isOutbound: true,
  //   isService: false,
  // },
];

export const ORDER_TYPES = {
  CUSTOMER: 1,
  MOLD: 2,
  MATERIALS: 3,
  PROCESSING: 4,
  TESTING: 5,
  MANUFACTURING: 6,
  SHIPMENT: 7,
};
